import {
  IntlCache,
  IntlShape,
  createIntl,
  createIntlCache,
} from "@formatjs/intl";

let cache: IntlCache;
let intl: IntlShape<string>;

// resuse previously created `intl` instance for perf reasons unless the locale has changed
// see https://formatjs.io/docs/intl
export const getIntl = (): IntlShape<string> => {
  if (cache == null) {
    cache = createIntlCache();
  }

  const locale = navigator.language ?? "en-US";
  if (intl == null || intl.locale !== locale) {
    intl = createIntl({ locale }, cache);
  }

  return intl;
};
